import * as THREE from "three";
import { state } from "../state";
import { focusOnExpressIdsFragments } from "../fragments/helpers";
import { controls, getActiveCamera, pointerNdc } from "../viewer/scene";
import { dom } from "../dom";
import { fragmentsRaycast } from "../fragments/ifc-shim";

/** Плавно выставляет камеру на набор express/local ID через Fragments bbox. */
export function focusOnExpressIds(expressIds: number[]): void {
  if (!state.ifcModel || expressIds.length === 0) {
    return;
  }
  void focusOnExpressIdsFragments(expressIds);
}

/**
 * Двойной клик по модели: переносит пивот орбиты на точку под курсором и
 * подтягивает камеру ближе к ней. Это снимает проблему «вращения вокруг
 * далёкого центра» и позволяет быстро подойти вплотную к нужному объекту
 * в плотной сцене.
 */
export async function focusCameraOnPointer(event: PointerEvent | MouseEvent): Promise<void> {
  if (!state.ifcModel) {
    return;
  }
  pointerNdc.x = event.clientX;
  pointerNdc.y = event.clientY;
  const hit = (await fragmentsRaycast(getActiveCamera(), pointerNdc, dom.canvas)) as
    | { point?: THREE.Vector3 }
    | undefined;
  const point = hit?.point;
  if (!point) {
    return;
  }

  const target = controls.target.clone();
  const eye = getActiveCamera().position.clone();
  const currentDistance = eye.distanceTo(target);
  const direction = eye.clone().sub(target);
  if (direction.lengthSq() < 1e-6) {
    direction.set(1, 0.7, 1);
  }
  direction.normalize();

  // Подходим к точке примерно на половину текущей дистанции, но не ближе
  // допустимого минимума — чтобы наезд ощущался, но без подрезания near.
  const newDistance = Math.max(currentDistance * 0.5, controls.minDistance * 4, 0.1);
  controls.target.copy(point);
  getActiveCamera().position.copy(point).addScaledVector(direction, newDistance);
  controls.update();
}
